import React from "react";
import Container from "react-bootstrap/Container";
import { Spinner } from "react-bootstrap";
import {
  EducationMaster,
  SubeducationMaster,
  subcastMaster,
  IncomeMaster,
  RegsitrationSave,
  StateMaster,
  DistrictMaster,
  TalukaMaster,
  RegistrationSelect,
  RegistrationUpdateProfile,
} from "../../AllApi/UserApi/UserApi";
import { useState, useEffect } from "react";
import axios from "axios";
import "../../UserComponents/UserComponent.css";
import { BaseIP } from "../../AllApi/UserApi/UserApi";
import { toast } from "react-toastify";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Form from "react-bootstrap/Form";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import dayjs from 'dayjs';

const FirstPage = (props) => {

  // Scroll to the top when component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // basic information
  const data = JSON.parse(sessionStorage.getItem("status"));

  const [Registrationid, setRegistrationid] = useState();
  const reg_id = JSON.parse(sessionStorage.getItem("Userid"));
  const userdata = JSON.parse(sessionStorage.getItem("userdata"));
  const [otherEduMaxLength, setOtherEduMaxLength] = useState(48);

  const gender1 = userdata.gender;

  const Email1 = userdata.email;
  const Mobno = userdata.mob_no;
  const FNameEn = userdata.fname;
  const MNameEn = userdata.mname;
  const LNameEn = userdata.lname;
  const dofb = userdata.dateofbirth;
  const FaFNameEn1 = userdata.mname;
  const FaLNameEn1 = userdata.lname;
  const member_id = userdata.id;
  //----------Registration Form basic information data save------------//

  const [Gender, setGender] = useState();
  const [Maritialsatatus, setMaritialsatatus] = useState();
  const [Disability, setDisability] = useState();
  const [Complextion, setComplextion] = useState();
  const [Enfname, setEnfname] = useState();
  const [Enmname, setEnmname] = useState();
  const [Enlname, setEnlname] = useState();
  const [Dateob, setDateob] = useState();
  const [BirthTime, setBirthTime] = useState();
  const [Height, setHeight] = useState();
  const [caste, setCaste] = useState();
  const [SubCaste, setSubCaste] = useState();

  const [Education, setEducation] = useState();
  const [EduCategory, setEduCategory] = useState([]);
  const [othereducation, setOthereducation] = useState(null);
  const [specificDegree, setSpecificDegree ] = useState(null);
  const [EduType, setEduType] = useState();
  const [OccupationDetail, setOccupationDetail] = useState();
  const [AnnualIncome, setAnnualIncome] = useState();

  const [AddressEn, setAddressEn] = useState();
  // const [AddressMr, setAddressMr] = useState();
  const [CityEn, setCityEn] = useState();
  const [pincode, setPincode] = useState();
  // const [CityMr, setCityMr] = useState();
  const [Taluka, setTaluka] = useState();
  const [District, setDistrict] = useState();
  const [State, setState] = useState();
  const [Email, setEmail] = useState();
  const [Mobno1, setMobno1] = useState();
  const [Mobno2, setMobno2] = useState();

  const [FaFNameEn, setFaFNameEn] = useState();
  const [FaMNameEn, setFaMNameEn] = useState();
  const [FaLNameEn, setFaLNameEn] = useState();
  const [FarmAcar, setFarmAcar] = useState();
  const [FarmGuntha, setFarmGuntha] = useState();
  const [OtherProperty, setOtherProperty] = useState(null);
  const [MarriedBro, setMarriedBro] = useState();
  const [UnMarriedBro, setUnMarriedBro] = useState();
  const [MarriedSis, setMarriedSis] = useState();
  const [UnMarriedSis, setUnMarriedSis] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [EducationData, setEducationData] = useState([]);
  const [SubeducationData, setSubeducationData] = useState([]);
  const [SubCastData, setSubCastData] = useState([]);
  const [IncomeData, setIncomeData] = useState([]);
  const [StateData, setStateData] = useState([]);
  const [DistictData, setDistictData] = useState([]);
  const [TalukaData, setTalukaData] = useState([]);

  const [isLoading, setIsLoading] = useState(false); // Add isLoading state

   const handlePinChange = (e) => {
    const value = e.target.value
    if (/^\d{0,6}$/.test(value)) {
      setPincode(value)
    }
  }

  const handalenlname = (e) => {
    setEnlname(e.target.value);
    setFaLNameEn(FaLNameEn1);
  };

  const handleSave = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const idArray = EduCategory.map((item) => item.id);
    const newEduCategory = idArray.join(", ");

    if (newEduCategory !== "") {
      
      const regdata = {
        gender: gender1,
        marital_status: Maritialsatatus,
        disability: Disability,
        complextion: Complextion,
        en_fname: FNameEn,
        en_mname: MNameEn,
        en_lname: LNameEn,
        mr_fname: FNameEn,
        mr_mname: MNameEn,
        mr_lname: LNameEn,
        dob: dofb,
        birth_time: BirthTime,
        height: Height,
        subcaste_id: SubCaste,
        edu_id: Education,
        // subedu_id: newEduCategory,
        subedu_id: EduCategory.map((item) => item.id).join(", "),
        other_education: othereducation,
        occupation: EduType,
        occupation_detail: OccupationDetail,
        income_id: AnnualIncome,
        en_address: AddressEn,
        mr_address: AddressEn,
        en_village: CityEn,
        mr_village: CityEn,
        taluka_id: Taluka,
        district_id: District,
        state_id: State,
        emailid: Email1,
        mobileno: Mobno,
        mobileno2: Mobno2,
        en_fatherfname: FaFNameEn1,
        en_fathermname: FaMNameEn,
        en_fatherlname: FaLNameEn1,
        mr_fatherfname: FaFNameEn1,
        mr_fathermname: FaMNameEn,
        mr_fatherlname: FaLNameEn1,
        farm_ac: FarmAcar,
        farm_g: FarmGuntha,
        other_property: OtherProperty,
        b_married: MarriedBro,
        b_unmarried: UnMarriedBro,
        s_married: MarriedSis,
        s_unmarried: UnMarriedSis,
        member_id: member_id,
        // disability_status: 1,
      };

      axios
        .post(RegsitrationSave, regdata)
        .then((res) => {
          setIsLoading(false);

          // if (res.data.message === "SAVED") {
          //   const userdata = res.data.userdata;

          //   sessionStorage.setItem("Userid", JSON.stringify(userdata.reg_id));
            
          //   toast.success("Saved Succesfully !", {
          //     position: "top-right",
          //     autoClose: 3000,
          //     hideProgressBar: false,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //   });

          //   setSubmitted(true);
          //   sessionStorage.setItem("status", 5);
          //   props.onSubmit();
          // }

          setSubmitted(true);
          sessionStorage.setItem("status", 5);
          props.onSubmit();
        })

        .catch((err) => console.log(err));
    } else {
      toast.error("Fill Education Please !", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  //UpdateApi
  const updatedata = () => {
    setIsLoading(true);
    const idArray = EduCategory.map((item) => item.id);
    const newEduCategory = idArray.join(", ");

    if (newEduCategory !== "") {
      const regdata = {
        reg_id: Registrationid,
        gender: gender1,
        marital_status: Maritialsatatus,
        disability: Disability,
        complextion: Complextion,
        en_fname: FNameEn,
        en_mname: MNameEn,
        en_lname: LNameEn,
        mr_fname: FNameEn,
        mr_mname: MNameEn,
        mr_lname: LNameEn,
        dob: dofb,
        birth_time: BirthTime,
        height: Height,
        subcaste_id: SubCaste,
        edu_id: Education,
        // subedu_id: newEduCategory,
        subedu_id: EduCategory.map((item) => item.id).join(", "),
        other_education: othereducation,
        occupation: EduType,
        occupation_detail: OccupationDetail,
        income_id: AnnualIncome,
        en_address: AddressEn,
        mr_address: AddressEn,
        en_village: CityEn,
        mr_village: CityEn,
        taluka_id: Taluka,
        district_id: District,
        state_id: State,
        emailid: Email1,
        mobileno: Mobno,
        mobileno2: Mobno2,
        en_fatherfname: FaFNameEn1,
        en_fathermname: FaMNameEn,
        en_fatherlname: FaLNameEn1,
        mr_fatherfname: FaFNameEn1,
        mr_fathermname: FaMNameEn,
        mr_fatherlname: FaLNameEn1,
        farm_ac: FarmAcar,
        farm_g: FarmGuntha,
        other_property: OtherProperty,
        b_married: MarriedBro,
        b_unmarried: UnMarriedBro,
        s_married: MarriedSis,
        s_unmarried: UnMarriedSis,
        member_id: member_id,
      };

      axios
        .put(RegistrationUpdateProfile, regdata)
        .then((res) => {
          setIsLoading(false);
          if (res.data.message === "UPDATED") {
            // alert("Profile UPDATED Successfully");
            toast.success("Profile Updated Succesfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });

            setIsEditing(false);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          // alert("Failed To Update Package, try again");
          toast.error("Failed To Update Package, try again!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    } else {
      toast.error("Fill Education Please !", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const [update, setUpdate] = useState(false);

  const getdata = () => {
    axios
      .get(`${RegistrationSelect}${member_id}`)
      .then((res) => {
        if (res.data.json !== null) {
          const api = res.data;

          api.map((api, index) => {
            setRegistrationid(api.reg_id);
            setGender(api.gender);
            setMaritialsatatus(api.marital_status);
            setDisability(api.disability);
            setComplextion(api.complextion);
            setDateob(api.dob);
            setFaFNameEn(api.en_mname);
            setFaLNameEn(api.en_lname);

            const timeParts = api.birth_time.split(" ");

            if (timeParts.length === 2) {
              // Extract hours, minutes, and AM/PM
              const [time, ampm] = timeParts;
              const [hoursStr, minutesStr] = time.split(":");

              // Convert hours to 24-hour format
              let hours = parseInt(hoursStr, 10);
              if (ampm === "PM" && hours !== 12) {
                hours += 12;
              } else if (ampm === "AM" && hours === 12) {
                hours = 0;
              }

              // Format the time as "HH:mm"
              const formattedTime = `${hours
                .toString()
                .padStart(2, "0")}:${minutesStr}`;

              // Set the formatted time as the initial value
              setBirthTime(formattedTime);
            }


            setHeight(api.height);
            setSubCaste(api.subcaste_id);

            setEducation(api.edu_id);

            axios
              .get(`${SubeducationMaster}/${api.edu_id}`)
              .then((res) => {
                if (res.data !== null) {
                  setSubeducationData(res.data);
                  const matchingOptions = res.data.filter((option) =>
                    api.subedu_id.includes(option.id)
                  );
                  setEduCategory(matchingOptions);                 
                }
              })
              .catch((err) => {
                console.log(err);
              });

            setEduType(api.occupation);
            setOccupationDetail(api.occupation_detail);
            setAnnualIncome(api.income_id);
            setAddressEn(api.en_address);
            setCityEn(api.en_village);
            setTaluka(api.taluka_id);
            setDistrict(api.district_id);
            setState(api.state_id);
            setEmail(api.emailid);
            setMobno1(api.mobileno);
            setMobno2(api.mobileno2);
            setFaFNameEn(api.en_fatherfname);
            setFaMNameEn(api.en_fathermname);
            setFaLNameEn(api.en_fatherlname);
            setFarmAcar(api.farm_ac);
            setFarmGuntha(api.farm_g);
            setOtherProperty(api.other_property);
            setOthereducation(api.other_education);
            setMarriedBro(api.b_married);
            setUnMarriedBro(api.b_unmarried);
            setMarriedSis(api.s_married);
            setUnMarriedSis(api.s_unmarried);
          });

          setIsEditing(false);
          setisMstatusEditing(false);
          setisDstatusEditing(false);

          setUpdate(true);
        }
      })
      .catch((error) => {
        console.log("===error===",error);        
      });
  };

  const [isEditing, setIsEditing] = useState(true);
  const [isMstatusEditing, setisMstatusEditing] = useState(true);
  const [isDstatusEditing, setisDstatusEditing] = useState(true);

  const handleEditClick = () => {
    setisMstatusEditing(false);
    setisDstatusEditing(false);
    setIsEditing(true);
    setUpdate(true);
  };

  const [userStatus, setUserStatus] = useState(null);

  //master use state and other code

  const status = JSON.parse(sessionStorage.getItem("status"));

  const getEducationData = () => {
    axios
      .get(EducationMaster)
      .then((res) => {
        if (res.data !== null) {
          setEducationData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSubeducationData = (educationId) => { 

    axios
      .get(`${SubeducationMaster}/${educationId}`)
      .then((res) => {
        if (res.data !== null) {
          setSubeducationData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setUserStatus(data);

    if (data > 3) {
      getdata();
    }
  }, []);

  const getSubCastData = () => {
    axios
      .get(subcastMaster)
      .then((res) => {
        if (res.data !== null) {
          setSubCastData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getIncomeData = () => {
    axios
      .get(IncomeMaster)
      .then((res) => {
        if (res.data !== null) {
          setIncomeData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getStateData = () => {
    axios
      .get(StateMaster)
      .then((res) => {
        if (res.data !== null) {
          setStateData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDistrictData = () => {
    axios
      .get(`${DistrictMaster}${State}`)

      .then((res) => {
        if (res.data !== null) {
          setDistictData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getTalukaData = () => {
    axios
      .get(`${TalukaMaster}${State}/${District}`)

      .then((res) => {
        if (res.data !== null) {
          setTalukaData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getEducationData();
    getSubCastData();
    getIncomeData();
    getStateData();
  }, []);

  useEffect(() => {
    getDistrictData();
    getTalukaData();
  }, [State, District]);

  const handleEducationChange = (newValue) => {
    const totalEducationLength = newValue.reduce(
      (sum, option) => sum + (option.subeducation_name?.length || 0),
      0
    );

    if (newValue.length <= 3 && totalEducationLength <= 50) {
      setEduCategory(newValue);
      const remainingLength = 50 - totalEducationLength;


       if (othereducation && othereducation.length > remainingLength) {
       setOthereducation(othereducation.slice(0, remainingLength));
       }

      setOtherEduMaxLength(remainingLength);
    } else if (totalEducationLength > 50) {
      toast.warn(
        "Total characters for Education and Other Qualification cannot exceed 50!",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    } else {
      toast.warn("Please select only three options!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <div className="row p-0 m-0">
      <Container className="p-0" >

        <div
          className="pe-5"
          style={{ display: "flex",  justifyContent: "end" }}
        >
          {userStatus > 3 ? (
            <>
              <p className="">
                {" "}
                <span
                  style={{
                    padding: "0px 10px",
                    backgroundColor: "#aaaaaa",
                    border: "1px solid white",
                    color:"grey"
                  }}
                ></span>{" "}
                &nbsp; Grey color fields are non editable
              </p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button
                className="rounded mb-0 "
                style={{
                  padding: "6px 15px",
                  backgroundColor: "rgb(233, 224, 227)",
                  border: "0px",
                  color: "rgb(134, 28, 18)",
                  marginBottom: "-40px",
                  fontSize: "16px",
                }}
                onClick={handleEditClick}
              >
                {" "}
                <b>Edit</b>
              </button>
            </>
          ) : null}
        </div>

        <Form onSubmit={handleSave} className="p-0 px-lg-5">
          {/* ==============================Basic Information ============================== */}
          <div   className="main-form "
            style={{ marginTop: "10px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                color: "red",
              }}
            >
              <h6>
                  All fields are mandatory<span>*</span>
              </h6>
            </div>

            <div
              className=" rounded shadow p-3 pb-4 "
              style={{ backgroundColor: "#fcc6b5" }}
            >
              
              <Row style={{ paddingTop: "" }}>
                <Col>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "10px",
                      borderBottom: "1px solid gray",
                      color: "rgb(134, 28, 18)",
                    }}
                  >
                    <div>
                      <h5>
                        <b>Basic Information -</b>
                      </h5>
                    </div>
                  </div>
                </Col>
              </Row>

               <Row style={{ paddingTop: "10px" }}>
                <Col sm={12}>
                  <Form.Label>
                    Candidate Name :
                  </Form.Label>
                </Col>
                <Col sm={12} md={4}>
                  <Form.Control
                    className="mt-1"
                    placeholder="First Name En"
                    value={FNameEn}
                    required
                    disabled
                  />
                </Col>
                <Col sm={12} md={4}>
                  <Form.Control
                    className="mt-1"
                    placeholder="Middle Name En"
                    value={MNameEn}
                    required
                    disabled
                  />
                </Col>
                <Col sm={12} md={4}>
                  <Form.Control
                    className="mt-1"
                    placeholder="Last Name En"
                    value={LNameEn}
                    onChange={(e) => handalenlname(e)}
                    required
                    disabled
                  />
                </Col>
              </Row>

              <Row style={{ paddingTop: "10px" }}>

                <Col sm={12} md={3} className="pt-1">
                  <Form.Label>Gender:</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={gender1}
                    onChange={(e) => setGender(e.target.value)}
                    required
                    disabled
                  >
                    <option value="">Select Gender</option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                  </Form.Select>
                </Col>

                <Col sm={12} md={3} className="pt-1">
                  <Form.Label>
                    Date Of Birth : <span></span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={dofb}
                    onChange={(e) => setDateob(e.target.value)}
                    required
                    disabled
                  />
                </Col>

                  <Col sm={12} md={3} className="pt-1">
                  <Form.Label>Birth Time :</Form.Label>
                  <Form.Control
                    type="time"
                    value={BirthTime}
                    onChange={(e) => setBirthTime(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  />
                </Col>

                <Col sm={12} md={3} className="pt-1">
                  <Form.Label>Height :</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={Height}
                    onChange={(e) => setHeight(e.target.value)}
                    data-validetta="required"
                    required
                    disabled={isEditing ? false : true}
                  >
                    <option value="">Choose...</option>
                    <option>Below 4 ft</option>
                    <option>4 ft &nbsp; 06 in</option>
                    <option>4 ft &nbsp; 07 in</option>
                    <option>4 ft &nbsp; 08 in</option>
                    <option>4 ft &nbsp; 09 in</option>
                    <option>4 ft &nbsp; 10 in</option>
                    <option>4 ft &nbsp; 11 in</option>
                    <option>5 ft</option>
                    <option>5 ft &nbsp; 01 in</option>
                    <option>5 ft &nbsp; 02 in</option>
                    <option>5 ft &nbsp; 03 in</option>
                    <option>5 ft &nbsp; 04 in</option>
                    <option>5 ft &nbsp; 05 in</option>
                    <option>5 ft &nbsp; 06 in</option>
                    <option>5 ft &nbsp; 07 in</option>
                    <option>5 ft &nbsp; 08 in</option>
                    <option>5 ft &nbsp; 09 in</option>
                    <option>5 ft &nbsp; 10 in</option>
                    <option>5 ft &nbsp; 11 in</option>
                    <option>6 ft</option>
                    <option>6 ft &nbsp; 01 in</option>
                    <option>6 ft &nbsp; 02 in</option>
                    <option>6 ft &nbsp; 03 in</option>
                    <option>6 ft &nbsp; 04 in</option>
                    <option>6 ft &nbsp; 05 in</option>
                    <option>6 ft &nbsp; 06 in</option>
                    <option>6 ft &nbsp; 07 in</option>
                    <option>6 ft &nbsp; 08 in</option>
                    <option>6 ft &nbsp; 09 in</option>
                    <option>6 ft &nbsp; 10 in</option>
                    <option>6 ft &nbsp; 11 in</option>
                    <option>7 ft</option>
                    <option>Above 7 ft</option>
                  </Form.Select>
                </Col>

              </Row>

              <Row style={{ paddingTop: "10px" }}>

               <Col sm={12} md={3} className="pt-1">
                  <Form.Label>Marital Status :</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={Maritialsatatus}
                    onChange={(e) => setMaritialsatatus(e.target.value)}
                    required
                    disabled={isMstatusEditing ? false : true}
                  >
                    <option value="">Select Marital Status </option>
                    <option value="1">Single</option>
                    <option value="2">Divorce</option>
                    <option value="3">Widow</option>
                    <option value="4">Widower</option>
                  </Form.Select>
                </Col>

                 <Col sm={12} md={3} className="pt-1">
                  <Form.Label>Cast :</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={caste}
                    onChange={(e) => setCaste(e.target.value)}
                    required
                     disabled={isEditing ? false : true}
                  >
                    <option value="">Select Cast </option>
                    <option value="1">Jain-Digambar</option>
                    <option value="2">Jain-Shwetambar</option>
                    <option value="3">Other</option>
                  </Form.Select>
                </Col>
                
                <Col sm={12} md={3} className="pt-1">
                  <Form.Label>Sub Caste :</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={SubCaste}
                    onChange={(e) => setSubCaste(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  >
                    <option value="">Choose...</option>
                    {SubCastData.map((value, index) => {
                      return (
                        <option value={value.id} key={index.id}>
                          {value.subcastename}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Col>

              </Row>
             
             
            </div>
          </div>

          {/* ==============Education & Occupation Information ====================== */}
          <div className="pt-3">
            <div
              className=" rounded shadow p-3 pb-4"
              style={{ backgroundColor: "#fcc6b5" }}
            >
             
              <Row style={{ paddingTop: "10px" }}>
                <Col>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "10px",
                      borderBottom: "1px solid gray",
                      color: "rgb(134, 28, 18)",
                    }}
                  >
                    <h5>
                      <b>
                        Education & Occupation Information
                      </b>
                    </h5>
                  </div>
                </Col>
              </Row>

              <Row style={{ paddingTop: "10px" }}>

              <Col sm={12} md={6} className="pt-1">
                  <Form.Label>
                    Educational Qualification :
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={Education}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setEducation(newValue);
                      setEduCategory([]);
                      if (newValue != null) {
                        getSubeducationData(newValue);
                      }
                    }}
                    required
                    disabled={!isEditing}
                  >
                    <option value="">Choose...</option>
                    {EducationData.map((value, index) => {
                      return (
                        <option value={value.id} key={index.id}>
                          {value.education_name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Col>

                <Col sm={12} md={6} className="pt-1">
                  <Form.Label>
                    Educational Category :
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={Education}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setEducation(newValue);
                      setEduCategory([]);
                      if (newValue != null) {
                        getSubeducationData(newValue);
                      }
                    }}
                    required
                    disabled={!isEditing}
                  >
                    <option value="">Choose...</option>
                    {EducationData.map((value, index) => {
                      return (
                        <option value={value.id} key={index.id}>
                          {value.education_name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Col>

                 <Col sm={12} md={6} className="pt-1">
                  <Form.Label>Specific Degree :</Form.Label>
                  <Form.Control
                    value={specificDegree}
                    onChange={(e) => {
                      if (e.target.value.length <= otherEduMaxLength) {
                        setSpecificDegree(e.target.value);
                      } else {
                        toast.warn(
                          `Maximum allowed characters for Specific Degree is ${otherEduMaxLength}`,
                          {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          }
                        );
                      }
                    }}
                    maxLength={otherEduMaxLength} 
                    disabled={isEditing ? false : true}
                  ></Form.Control>
                </Col>

                {/* <Col sm={12} md={6} className="pt-2">
                  <Form.Label>
                    Education : * You can select max. 3 options
                  </Form.Label>
                  <Autocomplete
                    multiple
                    id="movie-tags"
                    value={EduCategory}
                    disabled={!isEditing}
                    onChange={(event, newValue) => handleEducationChange(newValue)}
                    required
                    options={SubeducationData || []}
                    getOptionLabel={(option) =>
                      option.subeducation_name || "Unknown"
                    }
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          style={{ color: "black",backgroundColor:"white" }}
                          label={option.subeducation_name}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Add Education" />
                    )}
                  />
                </Col> */}

              </Row>

              <Row style={{ paddingTop: "10px" }}>

                <Col sm={12} md={6} className="pt-1">
                  <Form.Label>Other Qualification :</Form.Label>
                  <Form.Control
                    value={othereducation}
                    onChange={(e) => {
                      if (e.target.value.length <= otherEduMaxLength) {
                        setOthereducation(e.target.value);
                      } else {
                        toast.warn(
                          `Maximum allowed characters for Other Qualification is ${otherEduMaxLength}`,
                          {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                          }
                        );
                      }
                    }}
                    maxLength={otherEduMaxLength} 
                    disabled={isEditing ? false : true}
                  ></Form.Control>
                </Col>

                <Col sm={12} md={6} className="pt-1">
                  <Form.Label>Occupation Type :</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={EduType}
                    onChange={(e) => setEduType(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  >
                    <option value="">Choose...</option>
                    <option>Business</option>
                    <option>Profession</option>
                    <option>Govt-Job</option>
                    <option>Private-Job</option>
                    <option>Agriculture</option>
                    <option>Not Working</option>
                    <option>Studying</option>
                    <option>Other..</option>
                  </Form.Select>
                </Col>

              </Row>


              <Row style={{ paddingTop: "10px" }}>

                <Col sm={12} md={6} className="pt-1">
                  <Form.Label>
                    Occupation & Address:
                  </Form.Label>
                  <Form.Control
                    value={OccupationDetail}
                    onChange={(e) => setOccupationDetail(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  />
                </Col>

              </Row>
             
            </div>
          </div>

          {/* ============================Contact Information =================================== */}
          <div className="pt-3">
            <div
              className="rounded shadow p-3 pb-4 "
              style={{ backgroundColor: "#fcc6b5" }}
            >
            
              <Row style={{ paddingTop: "10px" }}>
                <Col>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "10px",
                      borderBottom: "1px solid gray",
                      color: "rgb(134, 28, 18)",
                    }}
                  >
                    <h5>
                      <b>Contact Information</b>
                    </h5>
                  </div>
                </Col>
              </Row>

              <Row style={{ paddingTop: "10px" }}>

                <Col sm={12} md={4} className="pt-1">
                  <Form.Label>State :</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={State}
                    onChange={(e) => setState(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  >
                    <option value="">Choose option</option>
                    {StateData.map((value, index) => {
                      return (
                        <option value={value.id}>
                          {value.stateenname}:{value.statemrname}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Col>

                <Col sm={12} md={4} className="pt-1">
                  <Form.Label>District :</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={District}
                    onChange={(e) => setDistrict(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  >
                    <option value="">Choose option</option>
                    {DistictData.map((value, index) => {
                      return (
                        <option value={value.id}>
                          {value.districtenname}:{value.districtmrname}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Col>

                <Col sm={12} md={4} className="pt-1">
                  <Form.Label>Taluka :</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={Taluka}
                    onChange={(e) => setTaluka(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  >
                    <option value="">Choose option</option>
                    {TalukaData.map((value, index) => {
                      return (
                        <option value={value.id}>
                          {value.talukaenname}:{value.talukamrname}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Col>

              </Row>

              <Row style={{ paddingTop: "10px" }}>

                <Col sm={12} md={3} className="pt-1">
                  <Form.Label>
                    Village/City:
                  </Form.Label>
                  <Form.Control
                    sm={12}
                    md={4}
                    value={CityEn}
                    onChange={(e) => setCityEn(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                    placeholder="Enter City/Village"
                  />
                </Col>

                <Col sm={12} md={2} className="pt-1">
               <Form.Group controlId="formPincode">
                <Form.Label>Pin Code:</Form.Label>
                <Form.Control
                  type="number" // use text instead of number to apply maxLength
                  value={pincode}
                  maxLength={6}
                  onChange={handlePinChange}
                  required
                  disabled={!isEditing}
                  placeholder="Enter Pincode"
                />
                {pincode && pincode.length > 0 && pincode.length < 6 && (
                  <div style={{ color: 'red', fontSize: '0.9rem' }}>
                    Pin code must be exactly 6 digits.
                  </div>
                )}
              </Form.Group>
                </Col>

                <Col sm={12} md={7} className="pt-1">
                  <Form.Label>
                    House/Colony/Road :
                  </Form.Label>
                  <Form.Control
                    sm={12}
                    md={8}
                    className="place"
                    placeholder="House Name/No/Road/Chowk/Colany/Landmark"
                    value={AddressEn}
                    onChange={(e) => setAddressEn(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  />
                </Col>

              </Row>

              <Row style={{ paddingTop: "10px" }}>

                <Col sm={12} md={4} className="pt-1">
                  <Form.Label>Email Id :</Form.Label>
                  <Form.Control
                    type="email"
                    value={Email1}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled
                  />
                </Col>

                <Col sm={12} md={4} className="pt-1">
                  <Form.Label>Whats App No. :</Form.Label>
                  <Form.Control
                    type="number"
                    value={Mobno}
                    onChange={(e) => setMobno1(e.target.value)}
                    required
                    disabled
                  />
                </Col>

                <Col sm={12} md={4} className="pt-1">
                  <Form.Label>Mobile No.2 :</Form.Label>
                  <Form.Control
                    type="number"
                    value={Mobno2}
                    maxlength="10"
                    title="Please enter 10 digit no."
                     onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        setMobno2(value);
                      }
                    }}
                    required
                    disabled={isEditing ? false : true}
                  />
                </Col>

              </Row>
            
            </div>
          </div>

          {/* ================Family Information =================================== */}
          <div className="pt-3">
            <div
              className="rounded shadow p-3 pb-4"
              style={{ backgroundColor: "#fcc6b5" }}
            >
              
              <Row style={{ paddingTop: "10px" }}>
                <Col>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingBottom: "10px",
                      borderBottom: "1px solid gray",
                      color: "rgb(134, 28, 18)",
                    }}
                  >
                    <h5>
                      <b>Family Information</b>
                    </h5>
                  </div>
                </Col>
              </Row>

              <Row style={{ paddingTop: "10px" }}>
                <Col sm={12} md={2} className="pt-1">
                  <Form.Label>Brother :</Form.Label>
                </Col>
                <Col sm={6} md={2} className="pt-1">
                  <Form.Label>Married Brothers (In Num.):</Form.Label>
                </Col>
                <Col sm={6} md={2}>
                  <Form.Select
                    aria-label="Default select example"
                    value={MarriedBro}
                    onChange={(e) => setMarriedBro(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  >
                    <option value="">Choose...</option>
                    <option>0</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                  </Form.Select>
                </Col>
                <Col sm={6} md={2} className="pt-1">
                  <Form.Label>Unmarried Brother (In Num.):</Form.Label>
                </Col>
                <Col sm={6} md={2}>
                  <Form.Select
                    aria-label="Default select example"
                    value={UnMarriedBro}
                    onChange={(e) => setUnMarriedBro(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  >
                    <option value="">Choose...</option>
                    <option>0</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                  </Form.Select>
                </Col>
              </Row>

              <Row style={{ paddingTop: "20px" }}>
                <Col sm={12} md={2} className="pt-2">
                  <Form.Label>Sister:</Form.Label>
                </Col>
                <Col sm={6} md={2} className="pt-2">
                  <Form.Label>Married Sister (In Num.) :</Form.Label>
                </Col>
                <Col sm={6} md={2}>                 
                  <Form.Select
                    aria-label="Default select example"
                    value={MarriedSis}
                    onChange={(e) => setMarriedSis(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  >
                    <option value="">Choose...</option>
                    <option>0</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                  </Form.Select>
                </Col>
                <Col sm={6} md={2} className="pt-3">
                  <Form.Label>Unmarried Sister (In Num.) :</Form.Label>
                </Col>
                <Col sm={6} md={2}>                
                  <Form.Select
                    aria-label="Default select example"
                    value={UnMarriedSis}
                    onChange={(e) => setUnMarriedSis(e.target.value)}
                    required
                    disabled={isEditing ? false : true}
                  >
                    <option value="">Choose...</option>
                    <option>0</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                  </Form.Select>
                </Col>
              </Row>
            
            </div>
          </div>

          {/* =================SAVE BUTTON==================== */}

          <div
            style={{
              display: "flex",
              justifyContent: "end",
              padding:"10px"
            }}
          >
            {!update ? (
              <button
                className="rounded py-1 px-2 shadow"
                type="submit"
                disabled={isLoading}
                style={{
                  backgroundColor: "orangered",
                  border:"none",
                  color: "black",
                  fontSize: "18px",
                  fontweight:"bold",
                }}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
            ) : (
              <button
                className="btn btn-save shadow"
                type="button"
                onClick={updatedata}
                disabled={isLoading}
                style={{
                  backgroundColor: "orangered",
                  border: "0px",
                  color: "black",
                  fontSize: "20px",
                }}
              >
                {isLoading ? "Updating..." : "Update"}
              </button>
            )}
          </div>

        </Form>

      </Container>
    </div>
  );
};

export default FirstPage;
